import React, { useState } from 'react';
import { AlertTriangleIcon, MinusIcon, RefreshCcwIcon, ZapIcon } from 'lucide-react';
import type { PlayerCri } from '../../types/neuro';
import { initials, toneClasses, type StatusIconKey, type StatusTone } from '../../utils/neuro';
export const StatusIcon = ({
  icon,
  className = 'w-4 h-4'
}: {
  icon: StatusIconKey;
  className?: string;
}) => {
  const props = {
    className,
    strokeWidth: 1.75,
    'aria-hidden': true
  };
  switch (icon) {
    case 'zap':
      return <ZapIcon {...props} data-id="element-500" data-mp="3brse5i6ux2am" />;
    case 'refresh':
      return <RefreshCcwIcon {...props} data-id="element-501" data-mp="3buemhk1knltw" />;
    case 'alert':
      return <AlertTriangleIcon {...props} data-id="element-502" data-mp="3gsg4e1n9hf3s" />;
    default:
      return <MinusIcon {...props} data-id="element-503" data-mp="3kt01543xagpe" />;
  }
};
export const PlayerAvatar = ({
  player,
  size
}: {
  player: PlayerCri;
  size: 40 | 56;
}) => {
  const [failed, setFailed] = useState(false);
  const dimension = size === 40 ? 'w-10 h-10 text-sm' : 'w-14 h-14 text-lg';
  if (player.photo_url && !failed) {
    return <img src={player.photo_url} alt="" onError={() => setFailed(true)} className={`${dimension} rounded-full object-cover flex-shrink-0`} data-id="element-504" data-mp="380y0bh3vbxfy" />;
  }
  return <span aria-hidden="true" className={`${dimension} rounded-full bg-[#F3F4F6] text-[#374151] font-semibold flex items-center justify-center flex-shrink-0`} data-id="element-505" data-mp="2yb4p4h7n1kc8">
      {initials(player.name)}
    </span>;
};
export const LimitedBadge = () => <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${toneClasses.moderate.bg} ${toneClasses.moderate.text}`} data-id="element-506" data-mp="3qzab17afhfdn">
    <AlertTriangleIcon className="w-3 h-3" strokeWidth={1.75} aria-hidden="true" data-id="element-507" data-mp="3h0b7g34is9xi" />
    Limited sample
  </span>;
export const NeuroBar = ({
  value,
  height = 'h-1.5'
}: {
  value: number;
  height?: string;
}) => <div className={`w-full ${height} rounded-full bg-[#E5E7EB] overflow-hidden`} aria-hidden="true" data-id="element-508" data-mp="25nqy0zqmfj01">
    <div className="h-full rounded-full bg-[#64748B]" style={{
    width: `${Math.max(0, Math.min(100, value))}%`
  }} data-id="element-509" data-mp="20ph38q8t6key" />
  </div>;
export const ToneChip = ({
  tone,
  children
}: {
  tone: StatusTone;
  children: React.ReactNode;
}) => <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${toneClasses[tone].bg} ${toneClasses[tone].text}`} data-id="element-510" data-mp="iqj249ht42j6">
    {children}
  </span>;